import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { AlertCircle, FileText } from 'lucide-react';
import { useProposalsGeneratePdf } from '../../hooks/use-proposals-generate-pdf.hook';

type ModalGeneratePDFProps = {
  policyId: string;
  productCode: string;
  stage: 'proposal' | 'quote';
  disabled?: boolean;
  /** Motivo exibido no `title` do botão quando desabilitado. */
  disabledReason?: string;
};

export function ModalGeneratePDF({
  policyId,
  productCode,
  stage,
  disabled,
  disabledReason,
}: ModalGeneratePDFProps) {
  const {
    mutate: generatePdf,
    isPending,
    isError,
    reset,
  } = useProposalsGeneratePdf(policyId);

  function handleGeneratePdf() {
    reset();
    generatePdf({ productCode, stage });
  }

  return (
    <Dialog.Root onOpenChange={() => reset()}>
      <Dialog.Trigger asChild>
        <Button
          variant='secondary'
          size='md'
          className='flex items-center gap-2 rounded-xl'
          disabled={disabled}
          title={disabled ? disabledReason : undefined}
        >
          <FileText className='size-5' />
          Baixar PDF
        </Button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content className='w-full max-w-md'>
            <Dialog.Header>
              <Dialog.Title>
                <FileText size={32} className='text-alba-black-500' />
                Baixar PDF
              </Dialog.Title>
              <Dialog.CloseTrigger asChild>
                <Dialog.CloseButton />
              </Dialog.CloseTrigger>
            </Dialog.Header>
            <Dialog.Body>
              {isError ? (
                <div className='flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3'>
                  <AlertCircle className='mt-0.5 h-5 w-5 shrink-0 text-red-500' />
                  <Text className='text-sm text-red-700'>
                    Não foi possível gerar o PDF. Tente novamente mais tarde.
                  </Text>
                </div>
              ) : (
                <>
                  <Text>O PDF da proposta será gerado para download.</Text>
                  <Text>Deseja continuar?</Text>
                </>
              )}
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.CloseTrigger asChild>
                <Button variant='ghost' size='md'>
                  Cancelar
                </Button>
              </Dialog.CloseTrigger>
              <Button
                variant='primary'
                size='md'
                onClick={handleGeneratePdf}
                disabled={isPending}
                loading={isPending}
              >
                {isError ? 'Tentar novamente' : 'Gerar e Baixar'}
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
